<template>
  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <select id="platform-package-base-type"
              v-model="localFormData.base_type"
              class="form-select"
              required>
        <option v-for="baseType in baseTypes" :key="baseType" :value="baseType">
          {{ $t(`platform_packages.base_types.${baseType}`) }}
        </option>
      </select>
      <label for="platform-package-base-type">{{ $t('platform_packages.base_type') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <select id="platform-package-source-kind"
              v-model="localFormData.source_kind"
              class="form-select"
              required>
        <option v-for="sourceKind in sourceKinds" :key="sourceKind" :value="sourceKind">
          {{ $t(`platform_packages.source_kinds.${sourceKind}`) }}
        </option>
      </select>
      <label for="platform-package-source-kind">{{ $t('platform_packages.source_kind') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <input id="platform-package-quantity"
             v-model.number="localFormData.quantity"
             type="number"
             min="1"
             step="1"
             class="form-control"
             required>
      <label for="platform-package-quantity">{{ $t('platform_packages.quantity') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <input id="platform-package-price"
             v-model.number="localFormData.price"
             type="number"
             min="0"
             step="0.01"
             class="form-control"
             required>
      <label for="platform-package-price">{{ $t('platform_packages.price') }} (€)</label>
    </div>
  </div>

  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <input id="platform-package-extra-price"
             v-model.number="localFormData.price_per_extra_quantity"
             type="number"
             min="0"
             step="0.01"
             class="form-control"
             required>
      <label for="platform-package-extra-price">{{ $t('platform_packages.price_per_extra_quantity') }} (€)</label>
    </div>
  </div>

  <div class="col-12 col-lg-4 mb-3">
    <div class="form-floating">
      <input id="platform-package-ends-at"
             v-model="localFormData.ends_at"
             type="datetime-local"
             class="form-control">
      <label for="platform-package-ends-at">{{ $t('platform_packages.ends_at') }}</label>
    </div>
  </div>
</template>

<script>
import {
  PLATFORM_PACKAGE_BASE_TYPES,
  PLATFORM_PACKAGE_SOURCE_KINDS,
} from '@/pages/platform_packages/helpers'

export default {
  name: 'PlatformPackageFormFields',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:formData'],
  data() {
    return {
      baseTypes: PLATFORM_PACKAGE_BASE_TYPES,
      sourceKinds: PLATFORM_PACKAGE_SOURCE_KINDS,
      localFormData: {...this.formData},
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.localFormData)) {
          this.localFormData = {...newValue}
        }
      },
    },
    localFormData: {
      deep: true,
      handler(newValue) {
        this.$emit('update:formData', {...newValue})
      },
    },
  },
}
</script>
